import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";

import Slider from "./Slider";
import HomeCardDeck from "./HomeCardDeck";
import colors from "../../colors";
//import pagecontent from "../Helpers/FloodContent";
//import AboutModal from "../../GeoportalModal";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  render() {
    return (
      <div
      className=" cardeck_full"
      
    >
      <div
      className="carddeck_inner"
        style={{
          // paddingTop: "0px",
          // paddingRight: "10px",
          // paddingBottom: "10px",
          // paddingLeft: "10px",
          backgroundColor: colors.background,
        }}
      >
        
          <Slider />
          <HomeCardDeck />
          {/* <div style={{padding:"10px"}}>
                <MDBCard style={{ width: "100%", }}>
                    <MDBCardBody>
                    <MDBCardTitle>Information</MDBCardTitle>
                       
                    </MDBCardBody>
                </MDBCard>
                </div>  */}
        </div>
      </div>
    );
  }
}

export default Home;
